import config from 'config'
import lang from '@/lang'
import { deliveryNoteStates } from '@/modules/base/util/constants'
const { DRAFT, DELIVERED } = deliveryNoteStates

const urls = {
  single: 'deliverynote',
  multiple: 'deliverynotes',
}

const resourceUrl = `${config.resourceHost}deliverynote`

export default {
  resourceUrl,
  apiUrl: config.resourceHost,
  deliveryNoteListSetting: `${config.resourceHost}setting/userlist/deliveryNote`,
  getNewDeliveryNote: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: DRAFT,
      title: lang.notDelivered,
      quickFilter: {
        state: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },
    {
      name: DELIVERED,
      title: lang.deliveryNoteDelivered,
      quickFilter: {
        state: {
          type: 'set',
          values: [DELIVERED],
        },
      },
    },
  ],
}
